import type { ReactNode } from "react";
import type { ToolKey } from "../config/toolRegistry";

// Same stroke style (1.7 width, round caps) as the four icons HomeMoreTools originally shipped, so
// the new cards don't look like a different component pasted in. Kept out of config/toolRegistry.ts
// (pure data, no JSX) because that module is also imported by scripts/homeSeoSnapshot.ts, which runs
// under tsconfig.node.json with no React/DOM — a JSX-emitting export there would break that build.
const TOOL_ICON_PATHS: Record<ToolKey, ReactNode> = {
  networkCheck: (
    <>
      <circle cx="12" cy="12" r="1.5" />
      <path d="M12 12a9 9 0 0 0-6.36 2.64M12 12a9 9 0 0 1 6.36 2.64M12 12V3" />
      <path d="M4.5 9.5a11 11 0 0 1 15 0" />
    </>
  ),
  environmentCheck: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
    </>
  ),
  dnsLeak: (
    <>
      <ellipse cx="12" cy="6" rx="8" ry="3" />
      <path d="M4 6v6c0 1.66 3.58 3 8 3s8-1.34 8-3V6" />
      <path d="M4 12v6c0 1.66 3.58 3 8 3s8-1.34 8-3v-6" />
    </>
  ),
  domainSecurity: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="m9 12 2 2 4-4" />
    </>
  ),
  webrtcLeak: (
    <>
      <circle cx="12" cy="12" r="2.3" />
      <path d="M7.5 7.5a7 7 0 0 0 0 9M16.5 7.5a7 7 0 0 1 0 9M4.5 4.5a11.5 11.5 0 0 0 0 15M19.5 4.5a11.5 11.5 0 0 1 0 15" />
    </>
  ),
  ipv6Leak: (
    <>
      <rect x="3" y="4" width="18" height="6" rx="1.5" />
      <rect x="3" y="14" width="18" height="6" rx="1.5" />
      <path d="M7 7h.01M7 17h.01M17 7h.01M17 17h.01" />
    </>
  ),
  speedTest: (
    <>
      <path d="M12 12 16 8" />
      <path d="M4 15a8 8 0 0 1 16 0" />
      <path d="M4 15h.01M20 15h.01M12 5v.01" />
    </>
  ),
  browserFingerprint: (
    <>
      <path d="M12 3 4.5 6v5.6c0 4.7 3.2 7.9 7.5 9.4 4.3-1.5 7.5-4.7 7.5-9.4V6L12 3Z" />
      <path d="m8.7 12 2.1 2.1 4.5-4.5" />
    </>
  ),
  claudeAccess: (
    <>
      <path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M18.4 5.6l-2.8 2.8M8.4 15.6l-2.8 2.8" />
      <circle cx="12" cy="12" r="2.5" />
    </>
  ),
};

export function ToolIcon({ tool }: { tool: ToolKey }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {TOOL_ICON_PATHS[tool]}
    </svg>
  );
}
